import { BaseQueryParams } from "../baseQuery";

export const supportedEntitiesService = BaseQueryParams(
  "supportedEntitiesService",
  ["SUPPORTED_ENTITIES", "ENTITIES_RELATIONS"],
).injectEndpoints({
  endpoints: (builder) => ({
    getEntities: builder.query({
      query: ({ page, per_page, filters }) => ({
        url: `/admin/migrations/supported/entities${
          page ? `?page=${page}` : ""
        }&per_page=${per_page ? `${per_page}` : ""}&config=1`,
        method: "GET",
        params: filters,
      }),

      providesTags: () => ["SUPPORTED_ENTITIES"],
    }),

    deleteEntity: builder.mutation({
      query: (id) => ({
        url: `/admin/migrations/supported/entities/${id}`,
        method: "Delete",
      }),

      invalidatesTags: () => ["SUPPORTED_ENTITIES"],
    }),

    createEntity: builder.mutation({
      query: (body) => ({
        url: "/admin/migrations/supported/entities",
        method: "POST",
        body,
      }),

      invalidatesTags: () => ["SUPPORTED_ENTITIES"],
    }),

    editEntity: builder.mutation({
      query: ({ id, body }) => ({
        url: `/admin/migrations/supported/entities/${id}`,
        method: "PUT",
        body,
      }),

      invalidatesTags: () => ["SUPPORTED_ENTITIES"],
    }),

    getEntitiesAttributes: builder.query({
      query: ({ page, per_page, filters }) => ({
        url: `/admin/migrations/supported/entities/attributes${
          page ? `?page=${page}` : ""
        }&per_page=${per_page ? `${per_page}` : ""}&config=1`,
        method: "GET",
        params: filters,
      }),

      providesTags: () => ["SUPPORTED_ENTITIES_ATTRIBUTES"],
    }),

    deleteEntityAttribute: builder.mutation({
      query: (id) => ({
        url: `/admin/migrations/supported/entities/attributes/${id}`,
        method: "Delete",
      }),

      invalidatesTags: () => ["SUPPORTED_ENTITIES_ATTRIBUTES"],
    }),

    createEntityAttribute: builder.mutation({
      query: (body) => ({
        url: "/admin/migrations/supported/entities/attribute",
        method: "POST",
        body,
      }),

      invalidatesTags: () => ["SUPPORTED_ENTITIES_ATTRIBUTES"],
    }),

    editEntityAttribute: builder.mutation({
      query: ({ id, body }) => ({
        url: `/admin/migrations/supported/entities/attributes/${id}`,
        method: "PUT",
        body,
      }),

      invalidatesTags: () => ["SUPPORTED_ENTITIES_ATTRIBUTES"],
    }),

    getEntitiesRelations: builder.query({
      query: ({ page, per_page, filters }) => ({
        url: `/admin/migrations/supported/relations${
          page ? `?page=${page}` : ""
        }&per_page=${per_page ? `${per_page}` : ""}&config=1`,
        method: "GET",
        params: filters,
      }),

      providesTags: () => ["ENTITIES_RELATIONS"],
    }),

    createEntitiesRelations: builder.mutation({
      query: (body) => ({
        url: "/admin/migrations/supported/relations",
        method: "POST",
        body,
      }),

      invalidatesTags: () => ["ENTITIES_RELATIONS"],
    }),

    editEntitiesRelations: builder.mutation({
      query: ({ id, body }) => ({
        url: `/admin/migrations/supported/relations/${id}`,
        method: "PUT",
        body,
      }),

      invalidatesTags: () => ["ENTITIES_RELATIONS"],
    }),

    deleteEntitiesRelations: builder.mutation({
      query: (id) => ({
        url: `/admin/migrations/supported/relations/${id}`,
        method: "Delete",
      }),

      invalidatesTags: () => ["ENTITIES_RELATIONS"],
    }),

    getEntitiesTree: builder.query({
      query: () => ({
        url: "/admin/migrations/supported/entities/configurations/tree",
        method: "GET",
      }),
    }),

    getEntitiesVersionsAndCarts: builder.query({
      query: () => ({
        url: "/admin/migrations/supported/entities/configurations/versions?source=1",
        method: "GET",
      }),
    }),

    getCartSupportedDetailsEntities: builder.query({
      query: () => ({
        url: "/admin/migrations/supported/entities/configurations",
        method: "GET",
      }),
    }),

    publishByFilter: builder.mutation({
      query: (body) => ({
        url: "/admin/migrations/supported/relations",
        method: "PATCH",
        body,
      }),

      invalidatesTags: () => ["ENTITIES_RELATIONS"],
    }),

    deleteByFilter: builder.mutation({
      query: (body) => ({
        url: "/admin/migrations/supported/relations",
        method: "Delete",
        body,
      }),

      invalidatesTags: () => ["ENTITIES_RELATIONS"],
    }),

    getDemoEntities: builder.query({
      query: ({ source_cart_id, target_cart_id }) => ({
        url: "/admin/migrations/supported/entities/configurations/pair",
        method: "GET",
        params: {
          source_cart_id,
          target_cart_id,
        },
      }),

      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetEntitiesQuery,
  useDeleteEntityMutation,
  useCreateEntityMutation,
  useEditEntityMutation,
  useGetEntitiesAttributesQuery,
  useDeleteEntityAttributeMutation,
  useCreateEntityAttributeMutation,
  useEditEntityAttributeMutation,
  useGetEntitiesRelationsQuery,
  useCreateEntitiesRelationsMutation,
  useEditEntitiesRelationsMutation,
  useDeleteEntitiesRelationsMutation,
  useGetEntitiesTreeQuery,
  useGetEntitiesVersionsAndCartsQuery,
  useGetCartSupportedDetailsEntitiesQuery,
  usePublishByFilterMutation,
  useDeleteByFilterMutation,
  useGetDemoEntitiesQuery,
} = supportedEntitiesService;
